// https://companywelfaresvil.poste.it/shopping/staticapi/v1/orders/1204462b-fd00-48bf-aaf0-8fcbbff08583
import type { refundApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

const apiBaseUrl = './refund/api/v1'

export const getRefund = http.get<{ refundId: string }, object, refundApi.Refund>(
  apiBaseUrl + '/refunds/:refundId',
  async ({ params }) => {
    const refunds = await (await fetch('./data/refund/refunds.json')).json()
    const refundId = params.refundId
    const item = (refunds?.items || []).find((item: refundApi.Refund) => item?.refundId === refundId)
    if (!item && refundId === 'refund') {
      const newRefund: refundApi.Refund = {
        refundId: 'refund',
        subject: {
          fiscalCode: 'RSSMRA80A01H501U',
          firstName: 'MARIO',
          lastName: 'ROSSI',
        },
        category: 'Spese affitto abitazione principale',
        kind: 'Spese affitto abitazione principale',
        date: '2026-01-26T16:31:24.481Z',
        status: {
          value: 'DRAFT',
          updatedAt: '2026-01-26T16:31:24.481Z',
        },
        documents: [],
        attributes: {
          limitType: 'welfareArt51',
          orderId: 'ISRBSFXHEMAB',
          subCategoryId: 'spese-affitto|1',
          userCampaignId: 'PTW2026',
          userChannel: 'pws',
          userCompanyCode: '97103880585',
          userEmail: 'FakeUser@MSWDATA.IT',
          userFiscalCode: 'RSSMRA80A01H501U',
          userMembershipId: 'fakeMembership1',
          userRegistrationNumber: '00000022',
          userUpn: 'FakeUser@MSWDATA.IT',
        },
        isCancelable: true,
        rule: {
          name: 'Spese affitto abitazione principale',
          kind: 'refund|05',
          allowedSubjects: ['dipendente', 'familiari'],
          period: ['2024 (fino al 20 novembre 2024)'],
          externalKeys: [],
          documents: [
            {
              name: 'Invoice',
              description: '<p></p>',
              types: ['invoice'],
              extractionType: 'invoice',
              min: 1,
              max: 1,
            },
          ],
          termsAndConditions: '',
          additionalAttributes: {},
        },
        detailUrl: '#/shop/refund/refund',
      }
      return HttpResponse.json(newRefund, {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      })
    } else if (!item) {
      return new HttpResponse('Refund not found', {
        status: 404,
        headers: {
          'Content-Type': 'application/json',
        },
      })
    } else {
      return HttpResponse.json(item, {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      })
    }
  },
)
